export default function() {
  return [
    {
      title: "Carga de facturas",
      htmlBefore: '<i class="material-icons">work</i>',
      to: "/pending"
    },
    {
      title: "Facturas ingresadas",
      htmlBefore: '<i class="material-icons">attach_money</i>',
      to: "/proccessed"
    }
  ];
}
